export enum LobbyType {
    SLOTSLOBBY = 'slotsLobby',
    LCLOBBY = 'lclobby',
  }